import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import { Action } from 'redux';
import {
  CreateRelease,
  CreateReleaseSuccess,
  CreateReleaseError,
} from '../action-creators';
import { CREATE_RELEASE } from '../actions';
import AppState from '../../state';
import { ReleaseTimePreset } from '@common/types/artist-preset/release-time';
import moment from 'moment';
import * as Sentry from '@sentry/react';
import { hasActiveSubscription } from '../../subscription-manager/selectors';

const getReleaseTime = (
  releaseTime?: ReleaseTimePreset
): string | undefined => {
  if (!releaseTime) {
    return undefined;
  }

  const hoursPadded = `${releaseTime.hour}`.padStart(2, '0');
  const minutesPadded = `${releaseTime.minutes}`.padStart(2, '0');
  const tzMarker = releaseTime.timezone >= 0 ? '+' : '-';
  const tzPadded = `${Math.abs(releaseTime.timezone)}`.padStart(2, '0');

  const date = moment(
    `2021-01-19 ${hoursPadded}:${minutesPadded} ${releaseTime.period.toLowerCase()} ${tzMarker}${tzPadded}:00`,
    'YYYY-MM-DD hh:mm a Z',
    true
  );

  return date.utc().format('HH:mm');
};

export const createReleaseEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateRelease>(CREATE_RELEASE),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      if (!hasActiveSubscription(state)) {
        return new CreateReleaseError('No active subscription');
      }
      try {
        const draft = await release.create({
          ...action.release,
          genres: state.presets?.presets?.genres || [],
          copyright: state.presets?.presets?.copyright,
          releaseTime: getReleaseTime(state.presets?.presets?.releaseTime),
          catalogTier: state.presets?.presets?.pricePerSingle,
          recordLabel: state.presets?.presets?.recordLabel || '',
          ownerId: state.artist.active?.id,
        });

        return new CreateReleaseSuccess(draft);
      } catch (err) {
        Sentry.captureException(err);
        return new CreateReleaseError((err as Error).message);
      }
    })
  );
